// extracted by mini-css-extract-plugin
export default {"participantScore":"ParticipantScore_participantScore__KAr5C","selectedScore":"ParticipantScore_selectedScore__xd7Rk"};